const stationAdapter = (data) => {
  return {
    id: data.id,
    name: data.name,
    original: data.original,
  };
};

export const locationAdapter = (data) => {
  const { country, city, stations } = data;

  return {
    id: data.id,

    type: data.type,
    name: data.name,
    original: data.original,

    stations: stations && stations.map(stationAdapter),
    country: country && {
      id: country.id,
      name: country.name,
      continentGroup: country.continent_group,
    },
    city: city && {
      id: city.id,
      name: city.name,
    },
  };
};

export const locationsAdapter = (items) => {
  return items?.map(locationAdapter) || [];
};
